import { ChartData } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import './chartConfig';

interface ItemSalesChartProps {
  chartData: ChartData<'line'>;
}

function ItemSalesChart({ chartData }: ItemSalesChartProps) {
  const { t } = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const label = context.dataset.label || '';
            return `${label}: ${context.parsed.y.toLocaleString('nl-NL')}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return value.toLocaleString('nl-NL');
          },
        },
      },
    },
  };

  return (
    <div>
      <h3>{t('financialdashboard.item-sales-chart-title')}</h3>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default ItemSalesChart;
